import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPABillingInfoStart,
  getPABillingInfoSuccess,
  getPABillingInfoFailure,
} from "../reducers/getPABillingInfoReducer.js";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getPABillingInfo = createAsyncThunk(
  "getPABillingInfo",
  async ({ Unique_ID }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getPABillingInfoStart());
      const token = Cookies.get("token");

      const params = {
        Unique_ID: Unique_ID,
        PaymentType: "COD",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/PA/GetBillingInfo`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getPABillingInfoSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getPABillingInfoFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
